import { render, staticRenderFns } from "./SponsorOption.vue?vue&type=template&id=9d794876"
import script from "./SponsorOption.vue?vue&type=script&lang=js"
export * from "./SponsorOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports